import request from '@/utils/request'
import APIS from '@/permissions/index'
import { getCheckList } from '@/permissions/util'

export function checkPermissions () {
  return request({
    ...APIS['@common/CHECK_PERMISSIONS'],
    data: getCheckList()
  })
}

export function getUserInfo () {
  return request(APIS['@common/GET_USER_INFO'])
}

export function logout () {
  return request(APIS['@common/LOGOUT'])
}
// 查看基地列表(当前登陆用户有权限的基地)
export function queryBases () {
  return request(APIS['@common/Query_Bases'])
}

export function queryOperatorType (params) {
  return request({
    ...APIS['@common/Query_OperatorType'],
    params
  })
}

// 查询所有产品类型(用于下拉)
export function queryAllProductTypes (params) {
  return request({
    ...APIS['@common/Query_AllProductTypes'],
    params
  })
}

export function queryAllProducts (params) {
  return request({
    ...APIS['@common/Query_AllProducts'],
    params
  })
}

export function queryOperatorYears (params) {
  return request({
    ...APIS['@common/Query_OperatorYears'],
    params
  })
}

export function queryProductTypeBySubsidy (params) {
  return request({
    ...APIS['@common/Query_ProductTypeBySubsidy'],
    params
  })
}
